var departaments = [
  'Bogotá',
  'Amazonas',
  'Antioquia',
  'Arauca',
  'Atl\u00e1ntico',
  'Bol\u00edvar',
  'Boyac\u00e1',
  'Caldas',
  'Caquet\u00e1',
  'Casanare',
  'Cauca',
  'Cesar',
  'Choc\u00f3',
  'Cundinamarca',
  'C\u00f3rdoba',
  'Guain\u00eda',
  'Guaviare',
  'Huila',
  'La Guajira',
  'Magdalena',
  'Meta',
  'Nari\u00f1o',
  'Norte de Santander',
  'Putumayo',
  'Quind\u00edo',
  'Risaralda',
  'San Andr\u00e9s y Providencia',
  'Santander',
  'Sucre',
  'Tolima',
  'Valle del Cauca',
  'Vaup\u00e9s',
  'Vichada'
]

export default {
  departaments
}



// WEBPACK FOOTER //
// ./src/vue/additionalData/departaments.js